export const createUniqueCountdownElement = () => {
  const uniqueId = `${Math.random()}`.substring(2);
  const countdownElement = `<div id="${uniqueId}"></div>`;
  $('body').append(countdownElement);
  const $countdownElement = $(`#${uniqueId}`);
  return $countdownElement;
};
